<!--筛选组建-->
<template>
  <div class="list-filter">
     <div class="filter-box">
      <RadioGroup type="button" :value="defaultYear" @on-change="yearFilter">
        <Radio v-for="(item, index) in allYear" :key="index" :label="item.id" :disabled="index===0">{{item.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="filter-box">
      <RadioGroup type="button" :value="defaultProject" @on-change="stateFilter">
        <Radio v-for="(item, index) in taskStatus" :key="index" :label="item.id" :disabled="index===0">{{item.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="filter-box">
      <RadioGroup type="button" :value="defaultMy" @on-change="fnTypeFilter">
        <Radio v-for="(item, index) in myStatus" :key="index" :label="item.id" :disabled="index===0">{{item.name}}</Radio>
      </RadioGroup>
    </div>
    <!--<loading v-if="isLoading"></loading>-->
  </div>
</template>

<script>
  import Loading from './popup/Loading'

  export default {
    name: 'project-filter',
    components: {
      Loading
    },
    data () {
      return {
        isLoading: false,
        taskStatus: [
          {name: '项目状态'},
          {name: '全部', id: 0},
          {name: '待PAR审核', id: 1},
          {name: 'PAR不通过', id: 2},
          {name: 'PAR通过', id: 3},
          {name: '待PIB审核', id: 4},
          {name: 'PIB不通过', id: 5},
          {name: '执行中', id: 6},
          {name: '已完成', id: 7},
        ],
        myStatus: [
          {name: '我的项目'},
          {name: '全部', id: 0},
          {name: '我创建的', id: 1},
          {name: '我审核的', id: 2},
          {name: '我参与的', id: 3}
        ]
      }
    },
    computed: {
      allYear(){
        let timList = [];
        let smallYears = '2018';
        let date = new Date();  //获取当前时间
        let NowYears = date.getFullYear();
        var Years = NowYears - smallYears;
        let arrTim = [];
        for (let index = 0; index <= Years; index++) {
          arrTim.push(NowYears--);
        }
        // arrTim.forEach((tim) => {
        //   timList.push(tim);
        // }); 
        // console.log(arrTim,'arrTim',timList,'timList')
        let Yearoption=[];//以一个Obj  push到Array里面
        Yearoption=[{name:'项目年份'},]
        for (let i = 0; i < arrTim.length; i++) {
              Yearoption.push({
                  id: arrTim[i],
                  name: arrTim[i]
                })
             }
        return Yearoption
      },
      defaultMy () {
        return this.$store.state.projects.filter.functionType
      },
      defaultProject () {
        return this.$store.state.projects.filter.state
      },
      defaultYear(){
         return this.$store.state.projects.filter.year
      },
      listParams () {
        return this.$store.state.projects.filter
      }
    },
    methods: {
      yearFilter(id){
        this.isLoading = true
        this.$emit('on-change', true)
        let data = JSON.parse(JSON.stringify(this.listParams))
        data.page = 1
        data.year = id
        let _cb = (data, code) => {
          this.isLoading = false
          this.$emit('on-change', false)
          if (code === 100014) {
            this.$cookie.delete('token')

            this.$router.push('/')
          }
        }
        //  this.$store.state.projects.isAddBuget=false;
         this.$store.dispatch('changeisAddBuget', false)
          console.log( this.$store.state.projects.isAddBuget,' this.$store.state.projects.isAddBuget')
        this.$store.dispatch('setProjectsList', {data, cb: _cb})
  
      },
      stateFilter (id) {
        this.isLoading = true
        this.$emit('on-change', true)
        let data = JSON.parse(JSON.stringify(this.listParams))
        if (id == 7) data.state = "7,8"
        else data.state = id
        data.page = 1
        let _cb = (data, code) => {
          this.isLoading = false
          this.$emit('on-change', false)
          // this.$store.state.projects.isAddBuget=false;
          if (code === 100014) {
            this.$cookie.delete('token')

            this.$router.push('/')
          }
        }
        this.$store.dispatch('changeisAddBuget', false)
        this.$store.dispatch('setProjectsList', {data, cb: _cb})
      },
      fnTypeFilter (id) {
        this.isLoading = true
        this.$emit('on-change', true)
        let data = JSON.parse(JSON.stringify(this.listParams))
        data.page = 1
        data.functionType = id
        let _cb = (data, code) => {
          this.isLoading = false
          this.$emit('on-change', false)
         
          // this.$store.state.projects.isAddBuget=false;
          if (code === 100014) {
            this.$cookie.delete('token')

            this.$router.push('/')
          }
        }
         this.$store.dispatch('changeisAddBuget', false)
         this.$store.state.projects.isAddBuget=false;
        
        this.$store.dispatch('setProjectsList', {data, cb: _cb})
      }
    }
  }
</script>

<style scoped lang="less">
  .list-filter {
    margin-bottom: 16px;
  }
  .filter-box {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    padding-left: 108px;
    position: relative;
    margin-bottom: -1px;
    .ivu-radio-group {
      margin-bottom: -1px;
    }
    .ivu-radio-wrapper {
      font-size: 14px;
      color: #343a40;
      background-color: #f8f9fa;
      height: 40px;
      line-height: 40px;
      width: 108px;
      text-align: center;
      padding: 0;
      border: 0 none;
      border-right: 1px solid #e9ecef;
      transition: none;
      border-radius: 0;
      border-bottom: 1px solid #e9ecef;
      border-left: 1px solid #e9ecef;
      margin-left: -1px;
      &:hover:not(.ivu-radio-wrapper-checked):not(:first-child) {
        color: #2d8ef8;
        background-color: #fff;

      }
      &:first-child {
        position: absolute;
        left: 0;
        top: 0;
        border-right: 0 none;

      }
    }
    .ivu-radio-wrapper-disabled {
      background-color: #fff;
    }
    .ivu-radio-wrapper-checked {
      background-color: #107cd9;
      box-shadow: 0 0 0;
      border-color: #107cd9;
      color: #fff;
    }
  }
</style>
